export const PledgeAutoFormTexts = {
  fillByNumber: 'Заполнить по номеру',
  alertText: 'При отправке заявки потребуется указать дополнительную информацию об автомобиле',
  loadCarInfo: 'Подгрузить данные',
  carInfoLoaded: 'Данные загружены',
  carInfoNotLoaded: 'Не смогли найти информацию о машине',
  tryLoadCarInfoAgain: 'Попробовать ещё раз',
};
